'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectAdministrationCtrl', ProjectAdministrationCtrl);

  ProjectAdministrationCtrl.$inject = ['$scope', '$stateParams', 'Auth', 'Utils', 'project', 'users',
    'errorMessageService', 'Labels', 'ProjectDataservice'];

  function ProjectAdministrationCtrl ($scope, $stateParams, Auth, Utils, project, users,
    errorMessageService, Labels, ProjectDataservice) {

    /* ========================================================================
    ==================================== model ================================
    ======================================================================== */

    $scope.LABELS = Labels;
    $scope.selected = {
      tab: 'general'
    };

    $scope.model = {
      isBeheerder: Utils.isUserManager(Auth, project),
      project: project,
      users: users,
    };

    $scope.updateProject = (updatedProj) => {
      $scope.model.project = updatedProj;
      ProjectDataservice.setProjectById(updatedProj._id, updatedProj);
    };

    /* ========================================================================
    =================================== methods ===============================
    ======================================================================== */

    $scope.switchView = function (toTab) {
      $scope.selected.tab = toTab;
    };
  }

})();
